<template>
  <v-container>
    <h2>Manage Tutorials</h2>
    <p><small>Add, edit and delete Tutorials</small></p>
    <br>
    <br>
    <div>

      <v-btn color="primary" @click="() => { addDialog = true }">Add Tutorial</v-btn>
    </div>
    <br>
    


    <v-row>
      <v-col v-for="(tutorial, index) in tutorials" :key="index" cols="12" md="6" lg="4">
        <v-card>
          <v-img :src="tutorial.cover_image"></v-img>
          <v-card-title>{{ tutorial.name }}</v-card-title>
          <v-card-text>
            <div>Duration: {{ tutorial.duration }}</div>
            <div>Category: {{ tutorial.category }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn :href="tutorial.video_url" target="_blank">Watch Tutorial</v-btn>
            <v-btn color="primary" @click="editTutorial(index)">Edit</v-btn>
            <v-btn color="error" @click="deleteTutorial(index)">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>Edit Tutorial</v-card-title>
        <v-card-text>
          <v-text-field v-model="editedTutorial.name" label="Field Name"></v-text-field>
          <v-text-field v-model="editedTutorial.cover_url" label="Cover URL"></v-text-field>
          <v-text-field v-model="editedTutorial.video_url" label="Video URL"></v-text-field>
          <v-text-field v-model="editedTutorial.duration" label="Duration"></v-text-field>
          <v-select v-model="editedTutorial.category" :items="categories" label="Category"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveTutorial">Save</v-btn>
          <v-btn @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" max-width="500px">
      <v-card>
        <v-card-title>Add Tutorial</v-card-title>
        <v-row>
          <v-col style="text-align: center; padding-left:50px">
            <v-progress-linear style="width:90%" v-if="progress >= 0" :value="progress"></v-progress-linear>
          </v-col>
        </v-row>
        
        <v-card-text>
          <v-text-field v-model="newTutorial.name" label="Field Name"></v-text-field>

         <div>
          <label class="custom-file-input">
            <span class="label-text">Upload Cover Image</span>
          <input accept="image/png, image/gif, image/jpeg" type="file" @change="onFileChange" label="cover url">
          </label>
         </div>

         <div class="mt-3">
          <label class="custom-file-input">
            <span class="label-text">Upload Video Content</span>
          <input accept="video/*"  type="file" @change="onVideoChange" >
          </label>
         </div>

          <v-text-field v-model="newTutorial.duration" label="Duration"></v-text-field>
          <v-select v-model="newTutorial.category" :items="categories" label="Category"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="progress != -1" color="primary" @click="addTutorial">Save</v-btn>
          <v-btn @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import { PromoService } from "@/services";
import * as storageService from "@/utils/firebase/storage";
import app from '@/main';

export default {

  data() {
    return {
      dialog: false,
      addDialog: false,
      coverFile: {},
      videoFile: {},
      tutorials: [],
      editedTutorial: {
        name: '',
        cover_image: '',
        video_url: '',
        duration: '',
        category: ''
      },
      newTutorial: {
        name: '',
        cover_image: '',
        video_url: '',
        duration: '',
        category: ''
      },
      categories: ['giftcard', 'crypto'],
      progress: -1 // initial value
    }
  },
  async mounted() {
    await this.getTutorials();
  },
  methods: {
    onFileChange(event) {
      // Store the selected file in the data property
      this.coverFile = event.target.files[0];
    },
    onVideoChange(event) {
      // Store the selected file in the data property
      this.videoFile = event.target.files[0];
    },
    async addTutorial() {
      try {
        app.$store.dispatch('toast', {
            message: 'uploading tutorial...',
            variant: 'info'
          });
           // Set progress to 0
    this.progress = 0;
        console.log(this.newTutorial, this.coverFile, this.videoFile);
         // Set progress to 0
    this.progress = 10;
    
    const data = await storageService.uploadImages('tutorials', 738464, this.coverFile);
    const video = await storageService.uploadImages('tutorials', 97263, this.videoFile);
    if(data) this.progress = 20;
    if(video) this.progress = 80;

        console.log('let check the data', data, 'let video be', video);
        this.newTutorial.cover_image = data;
        this.newTutorial.video_url = video;
        const result = await PromoService.addTutorialsModule(this.newTutorial);
        this.addDialog = false;
        if (result) {
       this.newTutorial =   {
        name: '',
        cover_image: '',
        video_url: '',
        duration: '',
        category: ''
      }
      
    this.progress = 100;
    setTimeout(()=>{this.progress = -1},500);
          app.$store.dispatch('toast', {
            message: 'tutorial uploaded successfully',
            variant: 'success'
          });
          await this.getTutorials();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTutorials() {
      try {
        const data = await PromoService.getAllTutorials();
        console.log(data);
        this.tutorials = data;
      } catch (error) {
        console.log(error);
      }
    },
    editTutorial(index) {

      // Copy the selected tutorial into the editedTutorial data object
      console.log(this.tutorials[index])
      this.editedTutorial = Object.assign({}, this.tutorials[index]);

      // Open the dialog box
      this.dialog = true;
    },
    async saveTutorial() {

      try {
        const data = await PromoService.editTutorialsModule(this.editedTutorial);
        console.log(data);
        this.dialog = false;
        if (data) {
          await this.getTutorials();
        }
      } catch (error) {
        console.log(error);
      }
      // Find the index of the edited tutorial in the original tutorials array
      const index = this.tutorials.findIndex(tutorial => tutorial === this.editedTutorial);

      // Update the tutorial's information with the edited data
      this.tutorials.splice(index, 1, this.editedTutorial);

      // Close the dialog box
      this.dialog = false;
    },
    async deleteTutorial(index) {
      try {
      // Implement your delete tutorial logic here
    if(!confirm(`Do you want to delete this tutorial ` + this.tutorials[index].name))  return ;
      console.log(`Deleting tutorial at index ${index}`);
     
        const data = await PromoService.deleteTutorial(this.tutorials[index]);
        console.log(data);
        this.dialog = false;
        if (data) {
          await this.getTutorials();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>


<style scoped>
.custom-file-input {
  display: inline-block;
  cursor: pointer;
  padding: 10px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.label-text {
  margin-right: 8px;
}

/* Hide the default file input */
.custom-file-input input[type="file"] {
  position: absolute;
  left: -9999px;
}
</style>